import { render, staticRenderFns } from "./BodyPresetGridThumbnail.vue?vue&type=template&id=f7ad7b6e&scoped=true"
import script from "./BodyPresetGridThumbnail.vue?vue&type=script&setup=true&lang=ts"
export * from "./BodyPresetGridThumbnail.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./BodyPresetGridThumbnail.vue?vue&type=style&index=0&id=f7ad7b6e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7ad7b6e",
  null
  
)

export default component.exports